import { GOODS_TYPE } from '@/modules/pricing/utils';
import React from 'react';
import ISOLogo from '@/images/layout/ISO-27001.png';
import SOC2Logo from '@/images/layout/SOC-2.svg';
import CCPALogo from '@/images/layout/CCPA.svg';
import GDPRLogo from '@/images/layout/GDPR.svg';
import SSLLogo from '@/images/layout/SSL.svg';
/**
 * 日文的pricing的faqs
 */
export const FAQS = [
  {
    title: (
      <>
        文字起こし
        <wbr />の<wbr />
        精度
        <wbr />は<wbr />
        どの程度
        <wbr />
        ですか？
      </>
    ),
    answer: (
      <p>
        フォーマル
        <wbr />な<wbr />
        会議
        <wbr />
        など、
        <wbr />
        整然とした
        <wbr />
        発言
        <wbr />が<wbr />
        行われる
        <wbr />
        場合
        <wbr />
        には、
        <wbr />
        認識率
        <wbr />は<wbr />
        98.86%
        <wbr />
        以上
        <wbr />と<wbr />
        なります。
        <wbr />
        ※収音
        <wbr />が<wbr />
        困難
        <wbr />な<wbr />
        場合は、
        <wbr />
        認識精度
        <wbr />に<wbr />
        影響
        <wbr />を<wbr />
        与える
        <wbr />
        可能性
        <wbr />が<wbr />
        あります。
        <wbr />
        文字起こし精度
        <wbr />を<wbr />
        向上させる
        <wbr />
        コツ
        <wbr />は<wbr />
        <a href="/how-to-improve-transcription-accuracy">こちら→</a>
      </p>
    ),
  },
  {
    title: (
      <>
        「3日間無料トライアル」
        <wbr />の<wbr />
        始め方
        <wbr />と<wbr />
        解約方法
        <wbr />を<wbr />
        教えてください。
      </>
    ),
    answer: (
      <>
        <p>
          <strong>
            Notta Web版
            <wbr />
            から
            <wbr />
            「3日間無料トライアル」
            <wbr />を<wbr />
            申し込む方法
          </strong>
        </p>
        <p>
          Notta Web版
          <wbr />に<wbr />
          ログイン
          <wbr />
          します。
          <wbr />
          画面左下
          <wbr />に<wbr />
          ある
          <wbr />
          「プレミアムプラン
          <wbr /> 3日間無料トライアル」
          <wbr />を<wbr />
          クリック
          <wbr />
          します。
          <wbr />
          または
          <wbr />
          文字起こし時間
          <wbr />の<wbr />下<wbr />
          にある
          <wbr />
          「3日間無料トライアルを開始」
          <wbr />を<wbr />
          クリックします。
        </p>
        <p>
          ※無料トライアル
          <wbr />
          期間終了後
          <wbr />
          は、
          <wbr />
          プレミアム年間プラン
          <wbr />で<wbr />
          自動更新（課金）
          <wbr />と<wbr />
          なります。
          <wbr />
          自動更新
          <wbr />
          による
          <wbr />
          継続
          <wbr />を<wbr />
          希望されない
          <wbr />
          場合、
          <wbr />
          トライアル
          <wbr />が<wbr />
          終了する前に
          <wbr />
          解約
          <wbr />の<wbr />
          お手続き
          <wbr />を<wbr />
          しておく
          <wbr />
          必要
          <wbr />が<wbr />
          あります。
          <wbr />
          3日間無料トライアル
          <wbr />
          中は
          <wbr />
          72時間以内
          <wbr />に<wbr />
          解約した場合、
          <wbr />
          ご請求
          <wbr />は<wbr />
          発生しません。詳しくは<a href="https://support.notta.ai/hc/ja/articles/17752924509211">こちら</a>
          <wbr />を<wbr />
          ご確認ください。
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        お支払方法
        <wbr />を<wbr />
        教えてください。
      </>
    ),
    answer: (
      <>
        <p>
          JCB, <wbr />
          VISA, <wbr />
          Mastercard, <wbr />
          Discover, <wbr />
          American Expressクレジットカード
          <wbr />を<wbr />
          使って
          <wbr />
          お支払いこと
          <wbr />が<wbr />
          可能です。
          <wbr />
          クレジットカード
          <wbr />の<wbr />
          ご利用
          <wbr />を<wbr />
          ご希望でない
          <wbr />
          場合
          <wbr />
          は、
          <wbr />
          銀行振り込み
          <wbr />
          による
          <wbr />
          <a href="/request">請求書払い</a>、
          <wbr />
          または
          <wbr />
          Apple ID
          <wbr />や<wbr />
          Google Play
          <wbr />
          での
          <wbr />
          決済
          <wbr />が<wbr />
          ご利用可能です。
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        請求書
        <wbr />や<wbr />
        領収書
        <wbr />の<wbr />
        発行
        <wbr />は<wbr />
        できますか？
      </>
    ),
    answer: (
      <>
        <p>
          <strong>
            請求書
            <wbr />の<wbr />
            発行
            <wbr />
            について
          </strong>
        </p>
        <p>
          請求書払い
          <wbr />
          は、
          <wbr />
          ビジネスプラン
          <wbr />
          および
          <wbr />
          エンタープライズプラン
          <wbr />で<wbr />
          のみ
          <wbr />
          利用可能
          <wbr />
          です。
          <wbr />
          プレミアムプラン
          <wbr />
          では
          <wbr />
          請求書
          <wbr />の<wbr />
          発行
          <wbr />は<wbr />
          行っておりません
          <wbr />
          ので、
          <wbr />
          ご了承ください。
        </p>
        <p>
          <strong>
            領収書
            <wbr />の<wbr />
            発行
            <wbr />に<wbr />
            ついて
          </strong>
        </p>
        <p>
          &lt;Apple ID
          <wbr />
          決済&gt;
          <br />
          領収書
          <wbr />や<wbr />
          請求書
          <wbr />
          に関しては
          <wbr />
          AppStore
          <wbr />
          での
          <wbr />
          決済後、
          <wbr />
          Apple
          <wbr />
          からの
          <wbr />
          メール
          <wbr />
          にて
          <wbr />
          送付されます
          <wbr />
          ので
          <wbr />
          そちらで
          <wbr />
          ご確認
          <wbr />
          可能
          <wbr />
          でございます。
          <wbr />
           購入履歴
          <wbr />
          などの
          <wbr />
          確認
          <wbr />
          に関しましては
          <wbr />
          以下
          <wbr />
          より
          <wbr />
          可能
          <wbr />
          となっております。
          <br />
          <a href="https://support.apple.com/ja-jp/HT204088">
            <wbr />
            App Store、
            <wbr />
            iTunes Store、
            <wbr />
            その他の
            <wbr /> Apple <wbr />
            メディアサービス
            <wbr />
            の購入履歴を確認する
          </a>
        </p>
        <p>
          &lt;Google Play
          <wbr />
          決済&gt;
          <br />
          Google Play
          <wbr />で<wbr />
          購入すると、
          <wbr />
          注文情報
          <wbr />が<wbr />
          記載された
          <wbr />
          確認メール
          <wbr />が<wbr />
          購入時に
          <wbr />
          使用した 
          <wbr />
          Google アカウント
          <wbr />
          宛てに
          <wbr />
          届きます。 
          <wbr />
          購入履歴
          <wbr />
          などの
          <wbr />
          確認
          <wbr />
          に関しましては
          <wbr />
          以下
          <wbr />
          より
          <wbr />
          可能
          <wbr />
          となっております。
          <br />
          <a href="https://support.google.com/store/answer/13714320?hl=ja&visit_id=638336274767994685-1867369659&rd=1">
            Google ストア
            <wbr />の<wbr />
            領収書
            <wbr />と<wbr />
            注文番号
            <wbr />を<wbr />
            確認する
          </a>
        </p>
        <p>
          &lt;Stripe決済
          <wbr /> (Web版)&gt;
          <br />
          Notta Web
          <wbr />で<wbr />
          有料プラン
          <wbr />を<wbr />
          購入する
          <wbr />
          場合は、
          <wbr />
          サービス内で
          <wbr />
          領収書
          <wbr />を<wbr />
          発行すること
          <wbr />
          ができます。
          <wbr />
          PCのみに
          <wbr />
          対応しています。
          <wbr />
          詳しくは
          <wbr />
          <a target="_blank" rel="noreferrer" href="https://support.notta.ai/hc/ja/articles/4402677165851">
            こちら
          </a>
          <wbr />を<wbr />
          ご確認ください。
        </p>
        <p>
          <strong>
            書類
            <wbr />の<wbr />
            発行
            <wbr />
            について
          </strong>
        </p>
        <p>
          Notta
          <wbr />
          ビジネスプラン
          <wbr />を<wbr />
          ご購入いただいた
          <wbr />
          お客様は、
          <wbr />
          書類
          <wbr />の<wbr />
          発行
          <wbr />を<wbr />
          ご希望
          <wbr />の<wbr />
          場合、
          <wbr />
          下記
          <wbr />の<wbr />
          連絡先
          <wbr />
          まで
          <wbr />
          ご連絡ください。
          <wbr />
          お手数ですが
          <wbr />
          フォーム
          <wbr />に<wbr />
          必要な
          <wbr />
          事項
          <wbr />を<wbr />
          ご記入
          <wbr />の<wbr />
          上、
          <wbr />
          ご送信ください。
          <wbr />
          書類
          <wbr />は<wbr />
          PDF形式で、
          <wbr />
          電子メール
          <wbr />に<wbr />
          添付し
          <wbr />
          お送りいたします。
          <wbr />
          書類
          <wbr />
          発行
          <wbr />
          依頼
          <wbr />は<wbr />
          <a rel="noreferrer" href="https://share.hsforms.com/1DuvumSiURzSpWbUDLJ8WpAnoue6" target="_blank">
            こちら
          </a>
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        有料プラン
        <wbr />の<wbr />
        解約方法
        <wbr />を<wbr />
        教えてください。
      </>
    ),
    answer: (
      <>
        <p>
          有料プラン
          <wbr />の<wbr />
          自動更新停止
          <wbr />の<wbr />
          手続き
          <wbr />を<wbr />
          ご希望
          <wbr />の<wbr />
          場合
          <wbr />
          は、
          <wbr />
          下記
          <wbr />を<wbr />
          確認
          <wbr />の<wbr />
          うえ
          <wbr />
          自動更新停止
          <wbr />の<wbr />
          手続き
          <wbr />を<wbr />
          行ってください。
        </p>
        <p>
          ※1. 有効期間
          <wbr />の<wbr />
          24時間前
          <wbr />
          までに
          <wbr />
          停止手続き
          <wbr />を<wbr />
          行ってください。
          <br /> ※2. 退会手続き
          <wbr />と<wbr />
          自動更新
          <wbr />の<wbr />
          停止操作
          <wbr />は<wbr />
          別操作
          <wbr />
          となります。
          <wbr />
          自動更新
          <wbr />の<wbr />
          停止操作
          <wbr />を<wbr />
          していない場合、
          <wbr />
          料金
          <wbr />が<wbr />
          発生する
          <wbr />
          可能性
          <wbr />が<wbr />
          あるため、
          <wbr />
          退会手続き
          <wbr />
          とは
          <wbr />
          別で
          <wbr />
          自動更新
          <wbr />の<wbr />
          停止操作
          <wbr />を<wbr />
          お試しください。
        </p>
        <p>
          iOS端末
          <wbr />で<wbr />
          定期購入
          <wbr />の<wbr />
          自動更新
          <wbr />を<wbr />
          解約する方法
          <wbr />は<wbr />
          下記の通り
          <wbr />
          です。
          <br />
          <a href="https://support.apple.com/ja-jp/HT202039">
            Apple
            <wbr />の<wbr />
            サブスクリプション
            <wbr />を<wbr />
            解約する
            <wbr />
            必要
            <wbr />が<wbr />
            ある場合
          </a>
          <br />
          Android 端末
          <wbr />で<wbr />
          定期購入
          <wbr />の<wbr />
          自動更新
          <wbr />を<wbr />
          解約する
          <wbr />
          方法
          <wbr />は<wbr />
          下記の通り
          <wbr />
          です。
          <br />
          <a href="https://support.google.com/googlenews/answer/7018481?co=GENIE.Platform%3DAndroid&hl=ja">
            Google Play
            <wbr />
            での
            <wbr />
            定期購入
            <wbr />の<wbr />
            解約、
            <wbr />
            一時停止、
            <wbr />
            変更
          </a>
        </p>
        <p>
          &lt;Web版&gt;
          <br />
          Notta Web版
          <wbr />に<wbr />
          ログインします。
          <wbr />
          画面左下
          <wbr />の<wbr />
          「アカウント」
          <wbr />を<wbr />
          クリックし、
          <wbr />
          「契約管理」ページ
          <wbr />で<wbr />
          「サブスクリプションの解約」
          <wbr />を<wbr />
          クリックします。詳しくは<a href="https://support.notta.ai/hc/ja/articles/4402669606427">こちら</a>
          <wbr />を<wbr />
          ご確認ください。
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        データ
        <wbr />の<wbr />
        安全性
        <wbr />は<wbr />
        どのように
        <wbr />
        保証
        <wbr />
        されて
        <wbr />
        いますか？
      </>
    ),
    answer: (
      <>
        <p>
          弊社は、
          <wbr />
          2022年に
          <wbr />
          Nottaサービス
          <wbr />の<wbr />
          セキュリティ
          <wbr />や<wbr />
          プライバシー原則
          <wbr />に<wbr />
          関する
          <wbr />
          内部統制
          <wbr />を<wbr />
          対象に、
          <wbr />
          国際セキュリティ認証
          <wbr />の<wbr />
          <a href="/news/info/202302121015">SOC2認証報告書</a>
          <wbr />を<wbr />
          取得しています。
          <wbr />
          SOC 2<wbr />
          （Service Organization Control Type 2）
          <wbr />
          は、
          <wbr />
          米国公認会計士協会
          <wbr />
          （AICPA）
          <wbr />が<wbr />
          開発した
          <wbr />
          サイバー
          <wbr />
          セキュリティ・
          <wbr />
          コンプライアンス・
          <wbr />
          フレームワーク
          <wbr />
          です。
          <wbr />
          さらに、
          <wbr />
          2023年9月
          <wbr />に<wbr />
          ISMS国際標準規格
          <wbr />
          <a href="/news/info/202309151400 ">「ISO 27001」認証</a>
          <wbr />を<wbr />
          取得
          <wbr />
          しています。
        </p>
        <p>
          <strong>
            すべて
            <wbr />の<wbr />
            データ
            <wbr />は<wbr />
            日本国内
            <wbr />に<wbr />
            保管
          </strong>
          <wbr />
          されており、
          <wbr />
          データ
          <wbr />は<wbr />
          多重暗号化
          <wbr />
          されて
          <wbr />
          送信・
          <wbr />
          保存される
          <wbr />
          ため、
          <wbr />
          業務担当者
          <wbr />も<wbr />
          個別
          <wbr />の<wbr />
          ユーザーデータ
          <wbr />を<wbr />
          特定して
          <wbr />
          確認する
          <wbr />
          こと
          <wbr />は<wbr />
          できません。
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        サポート体制
        <wbr />は<wbr />
        どのように
        <wbr />
        なって
        <wbr />
        いますか？
      </>
    ),
    answer: (
      <>
        <p>
          Nottaでは、
          <wbr />
          導入
          <wbr />
          から
          <wbr />
          運用
          <wbr />
          まで、
          <wbr />
          充実した
          <wbr />
          サポート体制
          <wbr />を<wbr />
          整えて
          <wbr />
          おります。
          <wbr />
          基本料金
          <wbr />や<wbr />
          機能比較、
          <wbr />
          導入サポート
          <wbr />
          など、
          <wbr />
          お客様
          <wbr />の<wbr />
          課題
          <wbr />や<wbr />
          活用フェーズ
          <wbr />に<wbr />
          応じた
          <wbr />
          最適な
          <wbr />
          サポートサービス
          <wbr />
          を、
          <wbr />
          弊社
          <wbr />の<wbr />
          専門スタッフ
          <wbr />が<wbr />
          ご案内
          <wbr />
          いたします。
        </p>
        <p>
          また、
          <wbr />
          システム
          <wbr />の<wbr />
          運用管理
          <wbr />・<wbr />
          保守
          <wbr />が<wbr />
          24時間
          <wbr />
          365日体制
          <wbr />
          で、
          <wbr />
          お客様
          <wbr />の<wbr />
          情報セキュリティ
          <wbr />を<wbr />
          維持する
          <wbr />
          こと
          <wbr />に<wbr />
          努めています。
          <a href="/security">
            「セキュリティ」
            <wbr />
            への
            <wbr />
            取り組み
            <wbr />に<wbr />
            ついて→
          </a>
        </p>
      </>
    ),
  },
];

export const PRICE_UNIT_PLAN_MAP = {
  [GOODS_TYPE.FREE]: {
    en: 'USD',
    ja: '円',
  },
  [GOODS_TYPE.PRO]: {
    en: 'USD/month',
    ja: '円/月',
  },
  [GOODS_TYPE.TEAM]: {
    en: 'USD/month',
    ja: '円/月',
  },
};

/**
 * 打折tag的文案
 */
export const OFF_TAG_CONTENT_MAP = {
  [GOODS_TYPE.PRO]: {
    en: '40% OFF',
    ja: '40% OFF',
  },
  [GOODS_TYPE.TEAM]: {
    en: '40% OFF',
    ja: '40% OFF',
  },
};

/**
 * 免费注册的按钮文案
 */
export const FREE_BTN_LABEL = {
  en: 'Get Started',
  ja: '無料ではじめる',
};

/**
 * 对比表格的title
 */
export const COMPARE_TABLE_TITLE_MAP = {
  en: 'Compare plans & features',
  ja: 'プラン比較',
};

/**
 * 价格的标志
 */
export const PRICE_UNIT_LANG_MAP = {
  en: 'USD',
  ja: '円',
};

/**
 * 时间单位
 */
export const TIME_LANG_MAP = {
  en: 'mins',
  ja: '分',
};

/**
 * 英文banner的logo
 */
export const COMPANY_LOGO_EN = [
  {
    src: 'https://www.notta.ai/pictures/Grammarly.png',
    alt: 'Grammarly',
  },
  {
    src: 'https://www.notta.ai/pictures/Salesforce.png',
    alt: 'Salesforce',
  },
  {
    src: 'https://www.notta.ai/pictures/Tulane University.png',
    alt: 'Tulane University',
  },
  {
    src: 'https://www.notta.ai/pictures/Procore.png',
    alt: 'Procore',
  },
  {
    src: 'https://www.notta.ai/pictures/Pwc.png',
    alt: 'Pwc',
  },
];

/**
 * 英文安全logo
 */
export const SECURITY_LOGOS_EN = [
  {
    src: ISOLogo,
    alt: 'ISO',
  },
  {
    src: SSLLogo,
    alt: 'SSL',
  },
  {
    src: SOC2Logo,
    alt: 'SOC 2',
  },
  {
    src: GDPRLogo,
    alt: 'GDPR',
  },
  {
    src: CCPALogo,
    alt: 'CCPA',
  },
];

/**
 * 英文faqs
 */
export const FAQS_EN = [
  {
    question: "What is a 'Workspace'?",
    answer: (
      <>
        <p>
          A workspace in Notta is a centralized hub where individuals or teams can access, organize, or search the
          recordings and transcribed content, from any device.
        </p>
        <p>
          If you are on a Business/Enterprise plan, members in the same team workspace can view and collaborate on
          content created by other members.
        </p>
      </>
    ),
  },
  {
    question: 'What payment methods do you support?',
    answer: (
      <>
        <p>
          You can make a payment using credit or debit cards on our Notta.ai website, or make in-app purchases through
          your Apple or Google account. For Enterprise plan orders, we also accept bank transfers.
        </p>
        <p>
          The supported card types are:
          <br />
          <ul>
            <li>American Express</li>
            <li>Discover</li>
            <li>Mastercard</li>
            <li>Visa</li>
            <li>JCB</li>
          </ul>
        </p>
      </>
    ),
  },
  {
    question: 'How secure is Notta?',
    answer: (
      <>
        <p>
          Protecting users&apos; data is our top priority. We host customer data on Amazon Web Services (AWS) and
          regularly back up your data to prevent loss.
        </p>
        <p>
          Additionally, Notta is SOC2 Type II and ISO 27001 certified and implements firewalls and access restrictions
          on our servers to preserve the integrity and security of your information. Learn more at
          <a href="/en/security">&nbsp;https://www.notta.ai/en/security</a>.
        </p>
      </>
    ),
  },
  {
    question: 'How can I change my subscription plan?',
    answer: (
      <>
        <p>
          If you want to switch from a monthly plan to an annual plan, you can directly switch to the Annual Plan in the
          billing section.
        </p>
        <p>
          However, if you want to switch from Pro to Business, or from an annual plan to a monthly plan, you will need
          to cancel your current plan and subscribe to a new one.
        </p>
        <p>
          <strong>Note</strong>: The current plan will remain active until the next renewal date and the new plan will
          take effect from the following billing period.
        </p>
      </>
    ),
  },
  {
    question: 'How do I cancel my subscription?',
    answer: (
      <>
        <p>
          If you cancel your plan before the next renewal cycle, you will retain access to paid features until the end
          of your subscription period.
        </p>
        <p>You can cancel your subscription with the following methods:</p>
        <p>
          <strong>Notta Web</strong>
          <br />
          <ul>
            <li>Log in to the Notta web.</li>
            <li>Click on your profile picture in the top right corner of the screen.</li>
            <li>Click on &ldquo;Billing&rdquo; &gt; &ldquo;Cancel Subscription&rdquo; to confirm cancelation.</li>
          </ul>
        </p>
        <p>
          <strong>App Store</strong>
          <br />
          Please refer to the following and complete the procedure.{' '}
          <a href="https://support.apple.com/en-us/HT202039" target="_blank" rel="noreferrer">
            How to cancel your Apple subscription
          </a>
        </p>
        <p>
          <strong>Google Play Store</strong>
          <br />
          Please refer to the following and complete the procedure.{' '}
          <a href="https://support.google.com/googlenews/answer/7018481" target="_blank" rel="noreferrer">
            Cancel, pause, or change your subscription on Google Play
          </a>
          .
        </p>
      </>
    ),
  },
  {
    question: 'Will my data be lost if I cancel my paid plan?',
    answer: (
      <>
        <p>
          No. Your transcription data will be saved even if you cancel your paid plan, however, you can only view the
          first 3 minutes of the transcript as a Free user. We suggest you export the transcript to local storage before
          downgrading your plan.
        </p>
      </>
    ),
  },
  {
    question: 'Do you offer a discount for students or educators?',
    answer: (
      <>
        <p>
          Yes, Notta is happy to offer educators and students a discount on the Notta Pro plan. Please sign up with your
          educational email and apply a discount when making a purchase.
        </p>
        <p>
          Learn more about{' '}
          <a
            href="https://support.notta.ai/hc/en-us/articles/17418832708251-How-to-apply-for-Notta-educational-discount"
            target="_blank"
            rel="noreferrer"
          >
            how to apply for an education discount
          </a>
          .
        </p>
      </>
    ),
  },
];
